exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assistive-text[data-v-d3495b66]{font-size:14px;color:var(--quaternary);margin-top:-1rem}", ""]);

// exports
